export const RangeFilter = ({config, onChange, value}) => {
    const {
        min: minOpt,
        max: maxOpt,
        prefix = "",
        suffix = "",
    } = config;

    const minVal = value?.[0] ?? null;
    const maxVal = value?.[1] ?? null;

    const setMinVal = (val) => onChange([val, maxVal]);
    const setMaxVal = (val) => onChange([minVal, val]);

    const formatVal = (val) => `${prefix}${val.toLocaleString()}${suffix}`;

    // Picks a step size based on magnitude: small numbers get finer buckets, large get coarser
    const getStep = (value) => {
        if (value < 500) return 100;
        if (value < 1000) return 250;
        if (value < 10000) return 500;
        if (value < 100000) return 5000;
        return 10000;
    };

    const generateRanges = (min, max) => {
        if (min === undefined || max === undefined || max <= min) return [];

        const result = [];
        let current = min;

        while (current < max) {
            const step = getStep(current);
            // Snap the next boundary to a clean multiple of the step
            const next = Math.min(Math.floor(current / step) * step + step, max);
            result.push([current, next]);
            current = next;
        }

        // Final open-ended bucket
        result.push([max, undefined]);
        return result;
    };

    const ranges = generateRanges(minOpt, maxOpt).map(([rMin, rMax]) => ({
        label: rMax === undefined ? `${formatVal(rMin)}+` : `${formatVal(rMin)} - ${formatVal(rMax)}`,
        val: [rMin, rMax]
    }));

    return (
        <div className="space-y-6">
            <div className="flex items-center gap-2">
                <input
                    type="number"
                    placeholder="min"
                    className="input input-bordered input-sm w-full rounded-md"
                    min={minOpt}
                    max={maxOpt}
                    value={minVal ?? ''}
                    onChange={e => setMinVal(e.target.value ? Number(e.target.value) : undefined)}
                />
                <span className="text-sm text-base-content/40">to</span>
                <input
                    type="number"
                    placeholder="max"
                    className="input input-bordered input-sm w-full rounded-md"
                    min={minOpt}
                    max={maxOpt}
                    value={maxVal ?? ''}
                    onChange={e => setMaxVal(e.target.value ? Number(e.target.value) : undefined)}
                />
            </div>

            <div className="space-y-1">
                {ranges.map((r, i) => {
                    const isChecked = minVal === r.val[0] && maxVal === r.val[1];
                    return (
                        <label key={i}
                               className="flex items-center gap-3 p-1 cursor-pointer hover:bg-base-50 rounded transition-colors group">
                            <input
                                type="checkbox"
                                className="checkbox checkbox-primary checkbox-sm rounded-md border-base-300"
                                checked={isChecked}
                                onChange={() => onChange(isChecked ? [undefined, undefined] : r.val)}
                            />
                            <span
                                className={`text-sm font-medium ${isChecked ? 'pt-dark-blue' : 'text-base-content/70'} transition-colors`}>
                                {r.label}
                            </span>
                        </label>
                    );
                })}
            </div>
        </div>
    );
};
